module.exports = __webpack_public_path__ + "img/Group 9153.ef501e3b.png";